import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import flowStepEnumerators from 'src/modules/flowStep/flowStepEnumerators';

export default [
  {
    name: 'name',
    label: i18n('entities.flowStep.fields.name'),
    schema: schemas.string(
      i18n('entities.flowStep.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'actionType',
    label: i18n('entities.flowStep.fields.actionType'),
    schema: schemas.enumerator(
      i18n('entities.flowStep.fields.actionType'),
      {
        "options": flowStepEnumerators.actionType
      },
    ),
  },
  {
    name: 'actionResources',
    label: i18n('entities.flowStep.fields.actionResources'),
    schema: schemas.relationToMany(
      i18n('entities.flowStep.fields.actionResources'),
      {},
    ),
  },
  {
    name: 'actionFolder',
    label: i18n('entities.flowStep.fields.actionFolder'),
    schema: schemas.relationToOne(
      i18n('entities.flowStep.fields.actionFolder'),
      {},
    ),
  },
];